import * as React from 'react'
import { Form } from 'react-bootstrap'
import *  as _ from 'lodash'
import { copyObject, randomId } from '../../../../utils'
import InputDatePicker from '../../../../components/InputDatePicker'
import NumberFormatValidate from '../../../../components/NumberFormatValidate'
import { parseFloatTotal } from '../Job'
import ButtonLoading from '../../../../components/ButtonLoading'

import { isNumeric, regexFindMatches } from '../../../../utils/utilsT'
import { JobWorkerT } from '../../../../types/JobWorker'
import { convertItemByWorker, getWorkerFlatPay, getWorkerPay } from '../JobUtils'
import { WorkerTypeTStrings } from '../../../../types/Company'
import { JobT, VariableExpenseT } from '../../../../types/Job'
import { OptionsItemsCogs } from '../OptionsFieldsJob'


const regexVariable = "[<][[a-zA-Z0-9\-._~\+\/=()]+[>]"


interface ResultParseItem {
    workerId: number | null
    crewIndex: number | null
    isAnonymous: boolean | null
    rate: number
    units: number
}



import { mergeOptions, generateOptionsCogsForCrew, CogsLineItemT } from './CogsLineItemUtils'

const variablesWorker = ['laborVariable', 'laborFlat']


interface CogsLineItemProps {
    job: JobT
    jobDuration: number
    cogsLineItem: CogsLineItemT
    index: number
    removeLineItem(index: number): void
    updateLineItem(index: number, lineItem: CogsLineItemT): void
}


const COGSLineItem: React.FunctionComponent<CogsLineItemProps> = (props): JSX.Element => {

    const workerFlatPay = React.useMemo(() => getWorkerFlatPay(props.job), [props.job])
    const workerPay = React.useMemo(() => getWorkerPay(props.job), [props.job])

    const updateCogsLineItem = (key: string, value: any): void => {
        let cogsLineItemClone = copyObject(props.cogsLineItem)
        let isDirty = _.has(cogsLineItemClone, "isDirty") && cogsLineItemClone.isDirty == true
        // if (!isDirty && key == "date") {
        //     cogsLineItemClone['isDirty'] = true
        // }
        if (!isDirty) {
            cogsLineItemClone['isDirty'] = true
        }

        if (key == "item" && isItemForWorker(value)) {
            let resultParseItem = parseItem(value, workerFlatPay, workerPay)
            cogsLineItemClone['rate'] = resultParseItem.rate
            cogsLineItemClone['units'] = resultParseItem.units
            cogsLineItemClone['total'] = cogsLineItemClone.rate * cogsLineItemClone.units
            cogsLineItemClone['workerId'] = !resultParseItem.isAnonymous ? resultParseItem.workerId : null
        }
        cogsLineItemClone[key] = value
        if (key == 'rate' || key == 'units') cogsLineItemClone.total = cogsLineItemClone.rate * cogsLineItemClone.units
        props.updateLineItem(props.index, cogsLineItemClone)
    }
    /**
       * 
       * @param item 
       * @param isRate 
       */
    const renderLabel = (item: string, isRate: boolean = true): string => {
        if (OptionsItemsCogs[item]) {
            let label = `${reflectorLabel(OptionsItemsCogs[item], isRate)}`
            return label != "" ? `, ${label}` : ""
        }
        if (!isRate) {
            return ", hours"
        }
        return `${isRate ? ', $/hour' : ', hours'}`;
    }
    /**
     * 
     * @param variable 
     * @param isRate 
     */
    const reflectorLabel = (variable: VariableExpenseT, isRate: boolean = true): string => {
        return isRate ? variable.rateLabel : variable.unitsLabel;
    }

    /**
     * sanitize
     * @param key 
     * @param verboseName 
     */
    const fixLabelOption = (key: string, verboseName: string) => {
        // const regex = "/" + regexVariable + "/g";

        let regex = new RegExp(`${regexVariable}`, "g")
        let match = regex.exec(props.cogsLineItem.id)
        if (_.isArray(match) && match[0]) {
            // extract
            let strMatch = extractVariable(match[0])
            let variable = String(props.cogsLineItem.id).replace(/(<|>)/mg, '').replace(strMatch, "");
            // console.log("strMatch", strMatch)
            // console.log("strMatch->strKey", variable)
            // console.log("strMatch->keyeeeeee", key)
            if (variablesWorker.includes(key)) {
                return `${verboseName} - ${_.startCase(strMatch)}`
            }
        }
        return verboseName
    }

    /**
     * 
     * @param item 
     * @returns 
     */
    const parseItem = (item: string, workerFlatPay: number, workerPay: number): ResultParseItem => {
        let result = {
            workerId: null,
            crewIndex: null,
            isAnonymous: null,
            rate: 0,
            units: 0,
        }
        const key = decodeItem(item)
        const isLaborFlat = key == "laborFlat" ? true : false

        let regex = new RegExp(`${regexVariable}`, "g")
        const matches = regexFindMatches(regex, item)


        matches.forEach((match, index) => {

            if (index == 0) {
                let variable = extractVariable(match)
                result.isAnonymous = isNumeric(variable) ? false : true
                let hourlyRate = isLaborFlat ? Number(parseFloat(`${workerFlatPay}`).toFixed(2)) : Number(parseFloat(`${workerPay}`).toFixed(2))

                if (!result.isAnonymous && !isLaborFlat) {
                    hourlyRate = getHourlyRateByWorkerId(variable, props.job.crew)
                }

                // console.log("hourlyRate", hourlyRate)
                let rate = isNumeric(hourlyRate) ? Number(parseFloat(`${hourlyRate}`).toFixed(2)) : 0
                let units = isLaborFlat ? 1 : isNumeric(hourlyRate) ? parseFloat(`${props.jobDuration}`) : 0
                result.rate = rate
                result.units = units
                result.workerId = variable
            } else if (index == 1) {
                result.crewIndex = extractVariable(match)
            }
        })

        return result;
    }

    /**
     * 
     * @param workerId 
     * @param crew 
     * @returns 
     */
    const getHourlyRateByWorkerId = (workerId, crew: Array<JobWorkerT>) => {
        let worker = crew.find((w) => w.id == workerId)
        if (worker) {
            return worker.hourlyRate
        }
        return 12
    }
   
    /**
     * 
     * @param item 
     * @returns 
     */
    const isItemForWorker = (item) => {
        let regex = new RegExp(`${regexVariable}`, "g")
        let match = regex.exec(item)
        if (_.isArray(match) && match[0]) {
            return true
        }

        return false
    }
    /**
     * 
     * @param key 
     * @param verboseName 
     */
    const decodeItem = (item: string) => {
        let regex = new RegExp(`${regexVariable}`, "g")
        const matches = regexFindMatches(regex, item)
        let str = item
        if (_.isArray(matches)) {
            matches.map((m, index) => {
                // extract
                let strItem = replaceVariable(str, m)
                str = `${strItem}`
            })
            return str
        }

        return item
    }

    /**
     * 
     * @param str 
     * @param matche 
     * @returns 
     */
    const replaceVariable = (str: string, match: string) => {
        let strMatch = extractVariable(match[0])
        let strItem = String(str).replace(/(<|>)/mg, '').replace(strMatch, "");
        return strItem
    }

    /**
     * 
     * @param match 
     * @returns 
     */
    const extractVariable = (match: string) => {
        let variable = String(match).replace(/(<|>)/mg, '');
        return variable
    }

    /**
     * 
     * @returns 
     */
    const ItemsOptions = (): Array<JSX.Element> => {
        let optionsCrew = generateOptionsCogsForCrew(props.job, OptionsItemsCogs)
        // console.log("optionsCrew",optionsCrew)
        let newOptions = mergeOptions(optionsCrew, OptionsItemsCogs)
        // console.log("newOptions", newOptions)
        return Object.keys(newOptions).map((key, index) => {
            // if (isItemForWorker() && !variablesWorker.includes(key)) {
            //     return null
            // }
            // let verboseName= 
            if (variablesWorker.includes(key)) {
                return null
            }

            return <option value={key} key={index}>{fixLabelOption(key, newOptions[key].verboseName)}</option>
        })
    }



    return (
        <div style={{ display: 'grid', gridTemplateColumns: '0.2fr 1fr 1fr 1fr 1fr 1fr 0.1fr', }}>
            <div className=" d-flex flex-row align-items-end" style={{ width: "100%" }}>

                <ButtonLoading className="btn btn-outline-primary"
                    style={{ paddingTop: 2, marginBottom: 8 }}
                    noShowResultMessageError
                    noShowResultMessageSuccess
                    // disabled={props.cogsLineItem.paid}
                    onClick={() => {
                        updateCogsLineItem('paid', !props.cogsLineItem.paid)
                    }}>
                    {props.cogsLineItem.paid ? "Paid" : "Pay"}
                </ButtonLoading>

            </div>
            <div>
                <Form.Label>Date</Form.Label>
                <InputDatePicker
                    id={`cogs-date-${props.index}`}
                    className="input-material"
                    style={{ width: '100%' }}
                    selectedDate={`${props.cogsLineItem.date ? props.cogsLineItem.date : ""}`}
                    onChangeDate={(val) => {
                        updateCogsLineItem('date', val)
                    }}
                    onChange={(val) => { }}
                    dateFormat="MM/dd/yyyy"
                    placeholder="Date"
                />
            </div>
            <div>
                <Form.Label>Item</Form.Label>
                <Form.Control
                    as='select'
                    className='input-material'
                    onChange={(event: any) => {
                        let value = event.target.value

                        updateCogsLineItem('item', value)
                    }}
                    value={props.cogsLineItem.item}>
                    {ItemsOptions()}
                </Form.Control>
            </div>
            <div>
                <Form.Label>Cost{renderLabel(props.cogsLineItem.item, true)}</Form.Label>
                <NumberFormatValidate
                    customInput={Form.Control}
                    className="input-material"
                    type="text"
                    defaultValue={`${props.cogsLineItem.rate}`}
                    value={`${props.cogsLineItem.rate}`}
                    onValueChange={(values) => {
                        const { formattedValue, value, floatValue } = values;
                        if (floatValue != props.cogsLineItem.rate) {
                            updateCogsLineItem('rate', floatValue)
                        }
                    }}
                    mask="_"
                    // prefix={'$'}
                    fixedDecimalScale={true}
                    decimalScale={2}

                />
                {/* <Form.Control
                    className='input-material'
                    onChange={(event: any) => { updateCogsLineItem('rate', event.target.value) }}
                    value={`${cogsLineItem.rate}`} /> */}
            </div>
            <div>
                <Form.Label>Units{renderLabel(props.cogsLineItem.item, false)}</Form.Label>
                <NumberFormatValidate
                    disabled={decodeItem(props.cogsLineItem.item) == "laborFlat"}
                    customInput={Form.Control}
                    className="input-material"
                    type="text"
                    defaultValue={`${props.cogsLineItem.units}`}
                    value={`${props.cogsLineItem.units}`}
                    onValueChange={(values) => {
                        const { formattedValue, value, floatValue } = values;
                        if (floatValue != props.cogsLineItem.units && props.cogsLineItem.item != "laborFlat") {
                            updateCogsLineItem('units', floatValue)
                        }
                    }}
                    mask="_"
                    // prefix={'$'}
                    fixedDecimalScale={true}
                    decimalScale={2}

                />

            </div>
            <div>
                <Form.Label>Total, $</Form.Label>
                <Form.Control
                    className='input-material'
                    value={`${parseFloatTotal(props.cogsLineItem.total)}`}
                    disabled />
            </div>

            <div className="d-flex flex-row align-items-end" style={{ position: "relative", width: "100%", }}>

                <div style={{ cursor: 'pointer', position: "absolute", right: 1, top: 1 }}
                    onClick={(): void => {
                        // props.removeLineItem('revenue', props.index)
                        // setShowAlertDelete(true)
                        props.removeLineItem(props.index)
                    }}>x</div>


            </div>

        </div>
    )
}

export default COGSLineItem